import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Wizard, WizardStep } from "@evergis/ui";

import { WizardWrapper } from "../../CopyResource/components/Layer/styled";
import { useImportContext } from "../importContext";
import { getLocation } from "../../../../ducks/location/selectors";
import { GDBImportFromLayersStep, GDBImportFromPanelStep, GDBImportFromProjectsStep } from "../types";
import { RoutePanelName } from "../../../../appConfig/types";

export const GDBImportWizard = () => {
  const { t } = useTranslation("dialogs");
  const { step } = useImportContext();
  const location = useSelector(getLocation);

  const allSteps = useMemo(
    (): Record<string, WizardStep> => ({
      layers: {
        label: t("import.selectObjects"),
        disabled: step > GDBImportFromPanelStep.Layers,
      },
      meta: {
        label: t("import.nameTheProject"),
        disabled: step > GDBImportFromProjectsStep.Meta,
      },
      target: {
        label: t("import.importTarget"),
        disabled: step > GDBImportFromLayersStep.Target,
      },
      complete: {
        label: t("import.complete"),
      },
    }),
    [step, t],
  );

  const filteredSteps = useMemo((): WizardStep[] => {
    const { layers, complete, meta, target } = allSteps;

    if (location.payload.panel === RoutePanelName.Layers) return [layers, complete];

    if (location.payload.tab === RoutePanelName.Projects) return [layers, meta, complete];

    if (location.payload.tab === RoutePanelName.Layers) return [layers, target, complete];

    return [];
  }, [allSteps, location.payload.panel, location.payload.tab]);

  return (
    <WizardWrapper>
      <Wizard currentStep={step - 1} steps={filteredSteps} />
    </WizardWrapper>
  );
};
